import React, { Component } from 'react';

class IconAddNoteGray extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="12.291" height="15.364" viewBox="0 0 12.291 15.364">
                <path id="Icon_material-note-add" data-name="Icon material-note-add" d="M13.682,3H7.536A1.534,1.534,0,0,0,6.008,4.536L6,16.827a1.534,1.534,0,0,0,1.529,1.536h9.226a1.541,1.541,0,0,0,1.536-1.536V7.609Zm-.768,5.377V4.152l4.225,4.225Z" transform="translate(-6 -3)" fill="#4e5b66" />
            </svg>

        );
    }
}

export default IconAddNoteGray;